<template lang="pug">
  .bottom-nav
    router-link.bottom-nav__lnk.bottom-nav__lnk--left(:to="links.prev.href")
      .bottom-nav__lnk-line
      .bottom-nav__lnk-txt
        | {{links.prev.txt}}
    button.bottom-nav__btn(type="button" v-if="btn && !links.link" v-on:click="popupLocal(btn.type, 'show')")
      | {{btn.title}}
    a.bottom-nav__btn(v-if="links.link", :href="links.link", target="_blank")
      | {{btn.title}}
    router-link.bottom-nav__lnk.bottom-nav__lnk--right(:to="links.next.href")
      .bottom-nav__lnk-txt
        | {{links.next.txt}}
      .bottom-nav__lnk-line.bottom-nav__lnk-line--reverse
</template>

<script>
  import {PopupHelpersVue} from '@/mixins/PopupHelpersVue';

  export default {
    name: 'BottomNav',

    mixins: [PopupHelpersVue],

    components: {

    },

    props: {
      links: {
        type: Object
      },
      btn: {
        default() {
          return {
            type: 'booking',
            title: 'Запланировать визит'
          }
        }
      }
    },

    methods: {
      popupLocal(type, action) {
        this.popup(type, action);
      }
    }
  }
</script>
